import React from 'react';
import { colorType, withTheme } from '../styling/theme';

const PartnerIcon = ({ grayColor }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 32 32">
    <g>
      <path
        d="M26.08 7H21.9A5 5 0 0 0 17 3h-2a5 5 0 0 0-4.9 4H5.92A4.93 4.93 0 0 0 1 11.92v12.16A4.93 4.93 0 0 0 5.92 29h20.16A4.93 4.93 0 0 0 31 24.08V11.92A4.93 4.93 0 0 0 26.08 7M15 5h2a3 3 0 0 1 2.81 2h-7.63A3 3 0 0 1 15 5M5.92 9h20.16A2.92 2.92 0 0 1 29 11.92v2.33L18.67 17.2a9.7 9.7 0 0 1-5.34 0L3 14.25v-2.33A2.92 2.92 0 0 1 5.92 9m20.16 18H5.92A2.92 2.92 0 0 1 3 24.08v-7.75l9.78 2.79a11.75 11.75 0 0 0 6.44 0L29 16.33v7.75A2.92 2.92 0 0 1 26.08 27"
        data-name="Layer 2"
        fill={grayColor.hex}
        opacity="1"
        data-original="#000000"
      />
    </g>
  </svg>
);

PartnerIcon.propTypes = {
  grayColor: colorType,
};

PartnerIcon.defaultProps = {
  grayColor: {},
};

export default withTheme(({ colors: { gray } }) => ({
  grayColor: gray,
}))(PartnerIcon);
